import React, { ReactNode } from "react";
import { GlobalStyle } from "./global-style";
import { GlobalFonts } from "@/shared/assets/fonts/fonts";

interface GlobalStyleProviderProps {
  children: ReactNode;
}

export const GlobalStyleProvider = ({ children }: GlobalStyleProviderProps) => {
  return (
    <>
      <GlobalStyle />
      <GlobalFonts />
      {children}
    </>
  );
};
